import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const ProjectsByCommitteeForCYRCimprovement = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Projects by committee for CYRC improvement" />
    </Box>
  );
};
